import { API_URL, USER_URL } from './config';

export function fetchQuestion(productId: string) {
  return fetch(`${API_URL}/v1/product?pdid=${productId}`)
    .then((res) => res.json())
    .then((res) => {
      const { faq_list: list = [] } = res?.ai_meta ?? {};
      return !list.length ? null : list[0];
    });
}

export function fetchToken(deviceId: string, clientId: string) {
  return fetch(`${USER_URL}/user/v1/device/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      device_id: deviceId,
      client_id: clientId,
    }),
  }).then((res) => {
    return res.json();
  });
}
